import { Form, Input, Button, Card, message } from 'antd'
import { LockOutlined, MailOutlined, GlobalOutlined } from '@ant-design/icons'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import '../i18n/i18n'

function Login({ onLogin }) {
  const { t, i18n } = useTranslation()
  const [loading, setLoading] = useState(false)
  const subdomain = window.location.hostname.split('.')[0]

  // نطبّق اتجاه الصفحة المحفوظ من قبل هنا أيضاً (حتى قبل تسجيل
  // الدخول)، بما أن Dashboard.js لا يُحمَّل بعد في هذه المرحلة
  useEffect(() => {
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr'
    document.documentElement.lang = i18n.language
  }, [i18n.language])

  const toggleLanguage = () => {
    const next = i18n.language === 'ar' ? 'en' : 'ar'
    i18n.changeLanguage(next)
    localStorage.setItem('app_language', next)
  }
  const handleLogin = async (values) => {
    setLoading(true)
    try {
      const res = await axios.post('/api/auth/login', {
        email: values.email,
        password: values.password,
        subdomain: subdomain === 'localhost' ? 'client1' : subdomain
      })
      localStorage.setItem('token', res.data.token)
      localStorage.setItem('user', JSON.stringify(res.data.user))
      message.success(t('login.welcomeMessage', { name: res.data.user.name }))
      // مهم: نمرّر كائن المستخدم فقط (res.data.user)، وليس الاستجابة
      // الكاملة (res.data التي تحتوي أيضاً token) — التمرير الخاطئ
      // السابق كان يجعل client_id متداخلاً بمستوى خاطئ في حالة React
      // (user.user.client_id بدل user.client_id)، فتفشل قراءته في
      // مكونات أخرى مثل WhatsApp.js وتستخدم القيمة الافتراضية دائماً.
      onLogin(res.data.user)
    } catch (err) {
      message.error(err.response?.data?.error || t('login.loginError'))
    }
    setLoading(false)
  }
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f0f2f5'
    }}>
      <Button
        icon={<GlobalOutlined />}
        onClick={toggleLanguage}
        style={{ position: 'absolute', top: 24, insetInlineEnd: 24 }}
      >
        {t('language.switchTo')}
      </Button>
      <Card
        style={{ width: 400, borderRadius: 12 }}
        title={
          <div style={{ textAlign: 'center', fontSize: 22, fontWeight: 'bold' }}>
            {t('login.title')}
          </div>
        }
      >
        <Form onFinish={handleLogin} layout="vertical">
          <Form.Item
            name="email"
            label={t('login.email')}
            rules={[
              { required: true, message: t('login.emailRequired') },
              { type: 'email', message: t('login.emailInvalid') }
            ]}
          >
            <Input
              prefix={<MailOutlined />}
              placeholder="example@email.com"
              size="large"
            />
          </Form.Item>
          <Form.Item
            name="password"
            label={t('login.password')}
            rules={[{ required: true, message: t('login.passwordRequired') }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="••••••••"
              size="large"
            />
          </Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            block
            size="large"
            loading={loading}
          >
            {t('login.submit')}
          </Button>
        </Form>
      </Card>
    </div>
  )
}

export default Login
